import React, { useEffect, useState } from "react";
import {
  Box,
  Grid2,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Button,
  CircularProgress,
  CardMedia,
} from "@mui/material";
import HeaderBack from "../Header_Back";
import events2 from "../../assets/images/events_2.png";
import CloseIcon from "@mui/icons-material/Close";
import event_date from "../../assets/images/event-date.svg";
import event_location from "../../assets/images/event-location.svg";
import orginer_pic from "../../assets/images/user-pic.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequests from "../../utils/useRequests";
import { format } from "date-fns";
import banner from "../../assets/images/banner.png";
import BackImage from '../../assets/images/back.svg';
import Snackbars from "../../utils/Snackbars";

const Eventsdetails = () => {
  const { e_id } = useParams();
  const [loading, setLoading] = useState(true);
  const { getRequest } = useRequests();
  const [detail, setDetail] = useState({
    first_name: "",
    last_name: "",
    name: "",
    address: "",
    location: "",
    start_datetime: "",
    end_datetime: "",
    short_description: "",
    description: "",
    banner: "",
  });
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleBuyTicket = () => {
    navigate(`/dashboard/events-details/book-ticket/${e_id}`);
  };
  const handleBuyTicketFromSecondaryMarket= () => {
    navigate(`/resell-market/ticket-list/${e_id}`);
  };

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const fetchEventDetails = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`event-details/${e_id}`);
      if (response && response.code === 200) {
        const data = response.data;
        const calculatedMaxDays = calculateMaxEventDays(data.start_datetime, data.end_datetime);
        setMaxEventDays(calculatedMaxDays);
        setDetail({
          first_name: data.first_name,
          last_name: data.last_name,
          name: data.name,
          address: data.address,
          location: data.location,
          start_datetime: data.start_datetime,
          end_datetime: data.end_datetime,
          time: data.start_time + " - " + data.end_time,
          short_description: data.short_description,
          description: data.description,
          banner: data.banner,
          organizer: data.organizer,
        });
        console.log("banner", data.banner);
      } else {
        setAlertData({
          variant: "error",
          message: response.message || "Failed to fetch event details",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
    setLoading(false);
    resetAlertData();
  };

  const [maxEventDays, setMaxEventDays] = useState(1);
  const calculateMaxEventDays = (startDate, endDate) => {
      if (!startDate || !endDate) return 1;
      
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
      
      return Math.min(diffDays, 10); // Max 10 days
  };

  useEffect(() => {
    localStorage.removeItem("redirectAfterLogin");
    localStorage.setItem("bookfrompopup", false);
    fetchEventDetails();
  }, [e_id]);

  const formatEventDate = (start, end, time) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");

    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
      };
    }
    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
    };
  };

  if (!detail) return <Typography>No event details found.</Typography>;

  let formatedData = {};
  if (!loading) {
    formatedData = formatEventDate(
      detail.start_datetime,
      detail.end_datetime,
      detail.time
    );
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}

      <Grid2 className="center-App" container direction="column">
        <Grid2 className='header_details' height={"221px"} sx={{ backgroundImage: `url("${detail.banner ? detail.banner : banner}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <Grid2 className='menu-Link' component={Link}  to={`/dashboard`}  style={{ cursor: 'pointer', opacity: 1 }}>
                <img src={BackImage} alt="Navbar" width={180} />
            </Grid2>
            <Typography className='categories-name'>Event Details</Typography>
            <Grid2 className="back-shadow-img"></Grid2>
        </Grid2>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              minHeight: "300px",
            }}
          >
            <CircularProgress color="primary" />
            <p>Loading ...</p>
          </Box>
        ) : (
          <Box sx={{ padding: "15px 15px", float: "left", width: "100%" }}> 
            <Grid2 container spacing={2} sx={{ float: "left", width: "100%" }}>
              <Grid2 item xs={12} sx={{ float: "left", width: "100%" }}>
                <Grid2 className="events-time">
                  {" "}
                  <Typography
                    sx={{ fontWeight: 500, color: "#6638A2", fontSize: "19px" }}
                  >
                    {maxEventDays}  Day's Event
                  </Typography>
                </Grid2>
                {/* <Grid2 className='events-time'><Typography sx={{ fontWeight: 500, color: "#6638A2", fontSize: "19px" }}>{daysCount} Day's Event</Typography></Grid2> */}
                <Typography
                  variant="h2"
                  className="title"
                  sx={{
                    marginBottom: "-5px",
                    fontSize: "32px",
                    marginTop: "20px",
                    color: "#6638A2",
                    fontWeight: "500",
                  }}
                >
                  {detail.name}
                </Typography>
              </Grid2>
              <Grid2
                item
                xs={12}
                className="fullWidth"
                sx={{ float: "left", width: "100%" }}
              >
                <Grid2
                  className="event-info"
                  sx={{ float: "left", width: "100%" }}
                >
                  <Grid2 className="event-image">
                    <img src={event_date} alt="" />
                  </Grid2>
                  <Grid2 className="event-des">
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {formatedData.formattedDate}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      {formatedData.time}
                    </Typography>
                  </Grid2>
                </Grid2>
                <Grid2
                  className="event-info"
                  sx={{ float: "left", width: "100%" }}
                >
                  <Grid2 className="event-image">
                    <img src={event_location} alt="" />
                  </Grid2>
                  <Grid2
                    className="event-des"
                    sx={{ float: "left", width: "100%" }}
                  >
                    {/* <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {detail.address}
                    </Typography> */}
                    <a
                      href={detail.location}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "#1976d2", fontWeight: "bold"  }}
                    >
                      {detail.address}
                    </a>
                  </Grid2>
                </Grid2>
                <Grid2
                  className="event-info"
                  sx={{ float: "left", width: "100%" }}
                >
                  <Grid2 className="event-image">
                    <img src={detail.organizer} alt="" />
                  </Grid2>
                  <Grid2
                    className="event-des"
                    sx={{ float: "left", width: "100%" }}
                  >
                    <Typography
                      sx={{
                        fontSize: "19px",
                        fontWeight: 500,
                        color: "#120D26",
                      }}
                    >
                      {detail.first_name}
                      {detail.last_name}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#747688",
                        fontSize: "13px,",
                        fontWeight: "500",
                      }}
                    >
                      Organizer
                    </Typography>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2
                item
                xs={12}
                className="fullWidth"
                sx={{ marginTop: "12px" }}
              >
                <Typography
                  variant="h4"
                  className="title"
                  sx={{ marginBottom: "15px" }}
                >
                  About
                </Typography>
                <Typography className="event-des fullWidth" dangerouslySetInnerHTML={{ __html: detail.description }}>
                </Typography>
                <Link onClick={handleClickOpen} className="read-more">
                  Read More
                </Link>
              </Grid2>
            </Grid2>
            <Grid2 className="button-bottom fullWidth" fullWidth>
              <Button
                className="btn-common"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleBuyTicket}
              >
                Buy Ticket
              </Button>
              <Button
                className="btn-common-border"
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ marginTop: 2 }}
                onClick={handleBuyTicketFromSecondaryMarket}
              >
                Buy From Secondary Market
              </Button>
            </Grid2>
          </Box>
        )}
      </Grid2>
      <Dialog open={open} onClose={handleClose} aria-labelledby="">
        <DialogTitle className="Modal-title">About Events </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText
            sx={{
              color: "#341439",
              fontSize: "18px",
              lineHeight: "31px",
              marginBottom: "10px",
            }}
            dangerouslySetInnerHTML={{ __html: detail.description }}
          >
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Eventsdetails;
